export const getAllFormConditions = () => ({
  url: `/org_form_conditions`,
});

export const getAllFormTypes = () => ({
  url: `/all_forms`,
});

export const addFormConditions = () => ({
  url: `/add_form_conditions`,
});

export const getFormConditionsByIdConfig = () => ({
  url: `/form_conditions`,
});

export const updateFormConditionsConfig = () => ({
  url: `/update_form_conditions`,
});

export const getFormConditionsConfig = () => ({
  url: `/get_form`,
});
